import _ from 'lodash';
import moment from 'moment';
import {
    translate
} from '../scripts/core/tools/translate';
import numeral from 'numeral';
import environment from '../scripts/environment';
declare var kendo: any;

export class SummaryExtendedRankingSpreadsheet {
    dataSource: any;
    dataFooter: any;
    dataColumns: any;
    period: any;
    name: any;
    typeSale: any;
    city: any;
    companySizes: any;

    constructor(dataSource: any, period: any, typeSale: any, options: any) {
        this.dataSource = dataSource.data;
        this.dataFooter = dataSource.footer;
        this.dataColumns = dataSource.columns;
        this.period = {
            end: options.endDate,
            start: options.startDate
        };
        this.typeSale = typeSale;
        this.city = options.title;
        this.companySizes = options.companySizesText.join(',');
        this.name = `${environment.get('CONFIG.CLIENT')}_Tabela Segmentos Estendida_${this.city}_v${moment().format('YYYYMMDD')}`;
    }
    get currentPeriod() {
        const start = `${this.period.start.substring(4,6)}/${this.period.start.substring(0,4)}`;
        const end = `${this.period.end.substring(4,6)}/${this.period.end.substring(0,4)}`;
        return {
            start,
            end
        };
    }

    get currentDatePeriod(){
        return {
            start: new Date(this.period.start),
            end: new Date(this.period.end)
        };
    }

    create() {
        const sections = [{
            key: 'main',
            text: `${translate(`Common.TotalRegistrationsBySegment`)} (${this.typeSale}) (${this.companySizes}) ${this.city} - ${this.currentPeriod.start} - ${this.currentPeriod.end}`,
            index: 0
        }];
        const headerTitles = [{
                key: 'main',
                // text: translate(`Common.Segment`),
                textAlign: 'center',
                index: 0
            },
            {
                key: 'main',
                // text: translate(`Common.Industry`),
                textAlign: 'center',
                index: 1
            },
            {
                key: 'main',
                // text: translate(`Common.Client`),
                textAlign: 'center',
                index: 2
            },
            {
                key: 'main',
                // text: translate(`Common.Areamarketshare`),
                textAlign: 'center',
                index: 3
            },
            {
                key: 'main',
                text: translate(`Common.BrandsMarketShare`),
                textAlign: 'center',
                index: 4
            }
        ];

        let mainColumns = [];
        _.map(this.dataColumns, (item) => {
            if (!_.isUndefined(item.field)) {
                mainColumns.push({
                    key: item.field,
                    text: item.title,
                    textAlign: 'center'
                });
            }else{
                return _.map(item.columns, (sec) => {
                    mainColumns.push({
                        key: sec.field,
                        text: sec.title,
                        textAlign: 'center'
                    });
                });
            }
        });

        let dynamicColumns = [];
        _.map(this.dataColumns, (item) => {
            if (_.isUndefined(item.field)) {
                return _.map(item.columns, (sec) => {
                    dynamicColumns.push({
                        key: sec.field,
                        text: sec.title,
                        format: '0,0.00%'
                    });
                });
            }
        });

        const sectionColumns = {
            main: mainColumns
        };

        const baseStyle = {
            textAlign: 'left',
            fontSize: 10,
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseHeaderStyle = {
            color: '#fff',
            fontSize: 10,
            bold: true,
            textAlign: 'center',
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseColorStyle = {
            main: '#616161',
            header: '#616161'
        };

        const baseBorderColorStyle = {
            main: '#eee',
            header: '#eee'
        };

        const baseBackgroundColorStyle = {
            main: '#fafafa',
            header: '#fafafa'
        };

        const headerStyle = _.reduce(sections, (acc, section) => {
            acc[section.key] = _.assign({}, baseHeaderStyle, {
                background: '#222B35'
            });
            return acc;
        }, {});

        const tableStyle = _.reduce(sections, (acc, section) => {
            acc[section.key] = _.assign({}, baseHeaderStyle, {
                background: '#5E7594'
            });
            return acc;
        }, {});



        const getCellStyle = (data, key) => {
            return _.assign({}, baseStyle, {
                background: baseBackgroundColorStyle[key],
                borderLeft: {
                    color: baseBorderColorStyle[key],
                    size: 1
                },
                borderRight: {
                    color: baseBorderColorStyle[key],
                    size: 1
                },
                borderTop: {
                    color: baseBorderColorStyle[key],
                    size: 1
                },
                borderBottom: {
                    color: baseBorderColorStyle[key],
                    size: 1
                }
            });
        };
        const getCellFooterStyle = (data, key) => {
            return _.assign({}, baseStyle, {
                background: '#8497B0',
                color: '#fff'
            });
        };

        const dataSource = _(this.dataSource)
            .groupBy(d => d.tabName)
            .value();

            _.forEach(this.dataSource, x => {
            x.IndustryValue = numeral(x.IndustryValue).format('0,0[.]00');
            x.FlagValue = numeral(x.FlagValue).format('0,0[.]00');
            x.MarketShareValue = numeral(x.MarketShareValue).format('0,0.00%');
            _.forEach(dynamicColumns, y=> {
                x[y.key]  = numeral(x[y.key]).format(y.format);
            });
        });
        _.forEach(this.dataFooter, x => {
            x.IndustryValue = numeral(x.IndustryValue).format('0,0[.]00');
            x.FlagValue = numeral(x.FlagValue).format('0,0[.]00');
            x.MarketShareValue = numeral(x.MarketShareValue).format('0,0.00%');
            _.forEach(dynamicColumns, y=> {
                x[y.key]  = numeral(x[y.key]).format(y.format);
            });
        });

        const sheets = _.map(dataSource, (data) => ({
            name: this.typeSale,
            filter: {
                ref: _.size(dynamicColumns) == 2 ? `A3:F3` : _.size(dynamicColumns) == 3 ? `A3:G3`: `A3:H3`,
                columns: []
            },
            rows: [{
                    index: 0,
                    height: 40,
                    cells: [
                        ..._.map(sections, (section) =>
                            _.assign({}, headerStyle[section.key], {
                                value: section.text,
                                index: section.index,
                                borderLeft: {
                                    color: baseBorderColorStyle[section.key],
                                    size: 1
                                },
                                borderRight: {
                                    color: baseBorderColorStyle[section.key],
                                    size: 1
                                }
                            }))
                    ]
                },
                {
                    index: 1,
                    height: 25,
                    cells: [
                        ..._.map(headerTitles, (section) =>
                            _.assign({}, tableStyle[section.key], {
                                value: section.text,
                                index: section.index,
                                // borderLeft: {
                                //     color: baseBorderColorStyle[section.key],
                                //     size: 1
                                // },
                                // borderRight: {
                                //     color: baseBorderColorStyle[section.key],
                                //     size: 1
                                // }

                            }))
                    ]
                },
                {
                    index: 2,
                    height: 25,
                    cells: [
                        ..._(sectionColumns)
                        .map((columns, key) =>
                            _.map(columns, (cell) =>
                                _.assign({}, tableStyle[key], {
                                    value: cell.text,
                                    wrap: true,
                                    index: cell.index,
                                    borderLeft: {
                                        color: baseBorderColorStyle[key],
                                        size: 1
                                    },
                                    borderRight: {
                                        color: baseBorderColorStyle[key],
                                        size: 1
                                    },
                                    borderTop: {
                                        color: baseBorderColorStyle[key],
                                        size: 1
                                    },
                                    borderBottom: {
                                        color: baseBorderColorStyle[key],
                                        size: 1
                                    }

                                })))
                        .flatten()
                        .value()
                    ]
                },
                ..._.map(data, d => {
                    return ({
                        cells: [
                            ..._(sectionColumns)
                            .map((columns, key) =>
                                _.map(columns, (cell, k) => {
                                    return _.assign({}, getCellStyle(d[cell.key], key), {
                                        value: d[cell.key],
                                        textAlign: cell.textAlign
                                    });
                                }))
                            .flatten()
                            .value()
                        ]

                    });
                }),
                ..._.map(this.dataFooter, d => {
                    return ({
                        cells: [
                            ..._(sectionColumns)
                            .map((columns, key) =>
                                _.map(columns, (cell, k) => {
                                    return _.assign({}, getCellFooterStyle(d[cell.key], key), {
                                        value: d[cell.key],
                                        textAlign: cell.textAlign
                                    });
                                }))
                            .flatten()
                            .value()
                        ]

                    });
                })
            ],
            columns: [{
                    index: 0,
                    width: 300
                },
                {
                    index: 1,
                    width: 110
                },
                {
                    index: 2,
                    width: 110
                },
                {
                    index: 3,
                    width: 180
                },
                ..._.map(dynamicColumns, index => ({
                    index: index + 4,
                    width: 180
                }))
            ],
            showGridLines: true,
            mergedCells: [
                _.size(dynamicColumns) == 2 ? 'A1:F1' : _.size(dynamicColumns) == 3 ? 'A1:G1': 'A1:H1',
                _.size(dynamicColumns) == 2 ? 'E2:F2' : _.size(dynamicColumns) == 3 ? 'E2:G2': 'E2:H2'
            ]
        }));

        const workbook = new kendo.ooxml.Workbook({
            sheets
        });

        workbook.saveAsExcel = () => {
            kendo.saveAs({
                dataURI: workbook.toDataURL(),
                fileName: `${this.name}_${moment().format('YYYYMMDD[_]HHmmss')}.xlsx`
            });
        };
        return workbook;
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/summary-extended-ranking.js